<template>
  <el-dialog
    title="选择抽奖礼品"
    :visible.sync="addvisible"
    width="50%"
    append-to-body
    @click="closeDialog"
  >
    <div class="innerBody">
      <el-table
        size="small"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        border
        ref="multipleTable"
        element-loading-text="拼命加载中"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="id" label="商品ID"> </el-table-column>
        <el-table-column prop="image" label="商品图片">
          <template slot-scope="scope">
            <img
              :src="$store.state.fileBaseUrl + scope.row.image"
              alt=""
              style="width: 100px; height: 100px"
            />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="商品标题"> </el-table-column>
        <el-table-column prop="pointsPrice" label="兑换积分"> </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirm()">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      loading: false, //是显示加载
      listData: [],
      pageparm: {
        pageNum: 1,
        pageSize: 10,
        total: 10,
        onSale: "",
      },
      addvisible: false,
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.pageparm);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    confirm() {
      this.$emit("confirm", this.multipleSelection);
      this.multipleSelection = [];
      this.addvisible = false;
    },
    init(arr) {
      this.addvisible = true;
    },
    closeDialog() {
      this.addvisible = false;
    },
    getdata(parameter) {
      this.loading = true;
      this.$request
        .getGoods(parameter)
        .then((res) => {
          this.loading = false;
          console.log(res.data);
          this.listData = res.data.list;
          // // 分页赋值
          this.pageparm.pageNum = res.data.pageNum;
          this.pageparm.pageSize = res.data.pageSize;
          this.pageparm.total = res.data.total;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageNum = parm.currentPage;
      this.pageparm.pageSize = parm.pageSize;
      this.getdata(this.pageparm);
    },
    // 搜索事件
    search() {
      this.getdata(this.pageparm);
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box {
  display: flex;
}
</style>





// WEBPACK FOOTER //
// src/views/tasks/gift.vue